import React, { createContext, useContext } from 'react';
const SuccessNavigationContext = /*#__PURE__*/createContext(undefined);

/**
 * Overrides how checkout leaves for the success page. Hosts that embed the flow
 * (e.g. the Quick Pay lightbox) route it into their container instead of
 * replacing the window.
 */
export const SuccessNavigationProvider = _ref => {
  let {
    navigate,
    children
  } = _ref;
  return /*#__PURE__*/React.createElement(SuccessNavigationContext.Provider, {
    value: navigate
  }, children);
};

/** The success-page navigation to use. Falls back to a full-window navigation outside a provider. */
export const useSuccessNavigation = () => {
  const override = useContext(SuccessNavigationContext);
  return React.useCallback(url => {
    if (override) {
      override(url);
      return;
    }
    window.location.assign(url);
  }, [override]);
};
//# sourceMappingURL=useSuccessNavigation.js.map